
import { EditedParticipation } from "../../../Partner/EditedPartner";
import { Filter } from "../../ParticipationFunctions/Filtering";
import { CellWithValidator, StickyHeader } from "../../../../components/Table/TableStyles";
import { offsetOneRow, offsetTwoRows, StateStyledCell } from "../../Styles/ParticipationTableStyles";
import { ValidatedIcon, ValidateFilter, ValidateFilterValue } from "../../../../components/Controls/ValidateControl";
import { TextFilter } from "../../../../components/Form/FormStyles";
import { formatYesNoConditional } from "../../../../entities";

export function CorsiaEligibleHeader() {
	return (
		<StickyHeader
			style={{
				...offsetOneRow,
				width: '200px',
				minWidth: '200px',
				maxWidth: '200px'
			}}>
			CC CORSIA Eligible
		</StickyHeader>
	)
}

export function CorsiaEligibleFilter({ filter, updateFilter }: { filter: Filter, updateFilter: (filter: Filter) => void }) {
	return (
		<StickyHeader style={{ ...offsetTwoRows }}>
			<CellWithValidator>
				<ValidateFilter
					value={
						filter?.CarbonCorsiaEligibleValidated ??
						ValidateFilterValue.Unset
					}
					onChange={(e) =>
						updateFilter({
							...filter,
							CarbonCorsiaEligibleValidated: e.value
						})
					}
				/>
				<TextFilter
					value={filter?.CarbonCorsiaEligible ?? ''}
					onChange={(e) =>
						updateFilter({ ...filter, CarbonCorsiaEligible: e.target.value })
					}
				/>
			</CellWithValidator>
		</StickyHeader>
	)
}

export function CorsiaEligibleContent({ ppn }: { ppn: EditedParticipation }) {
	return (
		<StateStyledCell
			editStatus={ppn.EditStatus}
			modified={ppn.PlantingProjectId.modified}>
			<CellWithValidator>
				<span>
					{ppn.PlantingProject.CarbonCorsiaEligibleValidated && (
						<ValidatedIcon />
					)}
				</span>
				<span>
					{formatYesNoConditional(ppn.PlantingProject.CarbonCorsiaEligible)}
				</span>
			</CellWithValidator>
		</StateStyledCell>
	)
}